import React from 'react';
import youtubeIcon from '../../assets/img/youtube.png';
import discordIcon from '../../assets/img/discord.png';
import mediumIcon from '../../assets/img/medium.png';
import twitterIcon from '../../assets/img/twitter.png';
import telegramIcon from '../../assets/img/telegram.png';
import './Community.css';
import { TitleBox } from "../Liquidity/Details/styled";

const Community = () => {
  const socialData = [
    {
      text: 'TELEGRAM',
      href: 'https://t.me/',
      icon: telegramIcon,
    },
    {
      text: 'TWITTER',
      href: 'https://twitter.com/',
      icon: twitterIcon,
    },
    {
      text: 'MEDIUM',
      href: 'https://medium.com/',
      icon: mediumIcon,
    },
    {
      text: 'DISCORD',
      href: 'https://discord.gg/',
      icon: discordIcon,
    },
    {
      text: 'YOUTUBE',
      href: 'https://www.youtube.com/',
      icon: youtubeIcon,
    },
  ];

  return (
    <section className="community" style={{ marginTop: "0px", marginBottom: "60px" }}>
      <TitleBox style={{ marginTop: "0px" }}>
        <h1 className="text-center h1">Join Us!</h1>
      </TitleBox>
      <div className="community-box">
        <p className="community-description">
          Join the Hodl Holdings community to stay updated with the latest news and
          events. Engage with other investors and enthusiasts.
        </p>
        <div className="social-icons">
          {socialData.map((platform, index) => (
            <a href={platform.href} target="_blank" rel="noopener noreferrer" key={index}>
              <div className="social-icon-box">
                <img src={platform.icon} alt={platform.text} width="48px" />
                <span>{platform.text}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Community;
